/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1ExamQuestionLibraryItemIdMutationRequest,
  PutApiV1ExamQuestionLibraryItemIdMutationResponse,
  PutApiV1ExamQuestionLibraryItemIdPathParams,
  PutApiV1ExamQuestionLibraryItemId400,
  PutApiV1ExamQuestionLibraryItemId401,
  PutApiV1ExamQuestionLibraryItemId404,
  PutApiV1ExamQuestionLibraryItemId500,
} from "../../types/examQuestionLibraryController/PutApiV1ExamQuestionLibraryItemId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1ExamQuestionLibraryItemId } from "../../clients/examQuestionLibraryController/putApiV1ExamQuestionLibraryItemId.ts";

export const putApiV1ExamQuestionLibraryItemIdMutationKey = () =>
  [{ url: "/api/v1/exam/question-library/item/:id" }] as const;

export type PutApiV1ExamQuestionLibraryItemIdMutationKey = ReturnType<
  typeof putApiV1ExamQuestionLibraryItemIdMutationKey
>;

export function putApiV1ExamQuestionLibraryItemIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1ExamQuestionLibraryItemIdMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1ExamQuestionLibraryItemIdMutationKey();
  return mutationOptions<
    PutApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamQuestionLibraryItemId400
      | PutApiV1ExamQuestionLibraryItemId401
      | PutApiV1ExamQuestionLibraryItemId404
      | PutApiV1ExamQuestionLibraryItemId500
    >,
    {
      id: PutApiV1ExamQuestionLibraryItemIdPathParams["id"];
      data: PutApiV1ExamQuestionLibraryItemIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1ExamQuestionLibraryItemId(id, data, config);
    },
  });
}

/**
 * @description Atualiza os dados de uma questão existente na biblioteca de questões. O id da questão é passado pela rota. O tipo do componente determina quais campos são processados. Para questões de lista, as opções removidas são excluídas automaticamente. **(Requer Authorization para autenticação)**
 * @summary Editar questão na biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/item/:id}
 */
export function usePutApiV1ExamQuestionLibraryItemId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1ExamQuestionLibraryItemIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1ExamQuestionLibraryItemId400
        | PutApiV1ExamQuestionLibraryItemId401
        | PutApiV1ExamQuestionLibraryItemId404
        | PutApiV1ExamQuestionLibraryItemId500
      >,
      {
        id: PutApiV1ExamQuestionLibraryItemIdPathParams["id"];
        data: PutApiV1ExamQuestionLibraryItemIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1ExamQuestionLibraryItemIdMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1ExamQuestionLibraryItemIdMutationKey();

  const baseOptions = putApiV1ExamQuestionLibraryItemIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamQuestionLibraryItemId400
      | PutApiV1ExamQuestionLibraryItemId401
      | PutApiV1ExamQuestionLibraryItemId404
      | PutApiV1ExamQuestionLibraryItemId500
    >,
    {
      id: PutApiV1ExamQuestionLibraryItemIdPathParams["id"];
      data: PutApiV1ExamQuestionLibraryItemIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamQuestionLibraryItemId400
      | PutApiV1ExamQuestionLibraryItemId401
      | PutApiV1ExamQuestionLibraryItemId404
      | PutApiV1ExamQuestionLibraryItemId500
    >,
    {
      id: PutApiV1ExamQuestionLibraryItemIdPathParams["id"];
      data: PutApiV1ExamQuestionLibraryItemIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamQuestionLibraryItemId400
      | PutApiV1ExamQuestionLibraryItemId401
      | PutApiV1ExamQuestionLibraryItemId404
      | PutApiV1ExamQuestionLibraryItemId500
    >,
    {
      id: PutApiV1ExamQuestionLibraryItemIdPathParams["id"];
      data: PutApiV1ExamQuestionLibraryItemIdMutationRequest;
    },
    TContext
  >;
}
